import { createRouter, createWebHistory } from 'vue-router';

export const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', component: () => import('./pages/Dashboard.vue'), meta: { title: 'Dashboard' } },
    { path: '/transactions', component: () => import('./pages/Transactions.vue'), meta: { title: 'Transactions' } },
    { path: '/spending', component: () => import('./pages/Spending.vue'), meta: { title: 'Spending' } },
    { path: '/investments', component: () => import('./pages/Investments.vue'), meta: { title: 'Investments' } },
    { path: '/plan', component: () => import('./pages/Plan.vue'), meta: { title: 'Plan' } },
    { path: '/import', component: () => import('./pages/Import.vue'), meta: { title: 'Import' } },
    { path: '/settings', component: () => import('./pages/Settings.vue'), meta: { title: 'Settings' } },
    { path: '/:pathMatch(.*)*', redirect: '/' },
  ],
});

router.afterEach((to) => {
  document.title = `${(to.meta.title as string | undefined) ?? 'Dashboard'} · Finances`;
});
